import { render, staticRenderFns } from "./BCXParticipate.vue?vue&type=template&id=3e197b38&scoped=true"
import script from "./BCXParticipate.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXParticipate.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXParticipate.vue?vue&type=style&index=0&id=3e197b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e197b38",
  null
  
)

export default component.exports